<template>
  <div class="posi-fixed">
    <div class="posi-box"></div>
    <div class="taber flex-row space-bet">
      <div
        class="item_box flex-colum"
        @click="handelTab(item, index)"
        v-for="(item, index) in labelData"
        :key="index"
      >
        <div class="img-box flex-center">
          <img v-if="active !== index" :src="item.imgUrl" class="tab-size" />
          <img v-else :src="item.ckimgUrl" class="istab-size" />
        </div>
        <div :class="active === index ? 'isfont' : 'font'">
          {{ item.label }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "GlodBtn",
  data() {
    return {
      labelData: [
        {
          label: "首页",
          imgUrl: require("@/assets/images/model-com/home.png"),
          ckimgUrl: require("@/assets/images/model-com/ckhome.png"),
          router: "/index",
        },
        {
          label: "我的",
          imgUrl: require("@/assets/images/model-com/my.png"),
          ckimgUrl: require("@/assets/images/model-com/ckmy.png"),
          router: "/my",
        },
      ],
    };
  },
  computed: {
    ...mapState("tabbar", ["active"]),
  },
  methods: {
    handelTab(item, index) {
      const currentPath = this.$route.path; // 获取当前路由路径
      if (currentPath !== item.router) {
        // 检查是否已经是当前页面路由
        this.$store.dispatch("tabbar/sendAcive", index);
        this.$router.push(item.router);
      } else {
        // 已经是当前页面，不执行跳转
        console.log("Already on the same route");
      }
    },
  },
};
</script>

<style lang="less" scoped>
@tabSize: 24px;
@tabSize2: 40px;
@whiteBgc: #ffffff;
@fontColorBai: #ffffff;
@fontColorHei: #333333;
@fontColorHui: #acacac;
.tab-size {
  width: @tabSize;
  height: @tabSize;
}
.istab-size {
  width: @tabSize2;
  height: @tabSize2;
}
.img-box {
  width: @tabSize2;
  height: @tabSize2;
}
.taber {
  width: 100%;
  height: 88px;
  font-size: 12px;
  line-height: 20px;
  background-color: @whiteBgc;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 99;
  box-shadow: 0px -1px 4px 0px rgba(0, 0, 0, 0.12);
  .isfont {
    color: @fontColorHei;
  }
  .font {
    color: @fontColorHui;
  }
}
.item_box {
  justify-content: center;
  align-items: center;
  flex: 1;
  //   margin-top: -13px;
}

.posi-fixed {
  position: relative;
  .posi-box {
    width: 100%;
    height: 100px;
    /* 可以添加样式来占据位置 */
  }
}
</style>
